import { render, staticRenderFns } from "./NotFoundError.vue?vue&type=template&id=057113ad&"
import script from "./NotFoundError.vue?vue&type=script&lang=js&"
export * from "./NotFoundError.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundError.vue?vue&type=style&index=0&id=057113ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports